import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStackCheckLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_17667_5776)",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "path-1-inside-1_17667_5776",
				fill: "white",
				children: /* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M9 11.5L0 96L48 86V80.3393L9 88V11.5Z"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9 11.5L0 96L48 86V80.3393L9 88V11.5Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 96L-0.994376 95.8941L-1.13974 97.2589L0.203954 96.979L0 96ZM9 11.5H10L8.00562 11.3941L9 11.5ZM48 86L48.204 86.979L49 86.8131V86H48ZM48 80.3393H49V79.1237L47.8073 79.358L48 80.3393ZM9 88H8V89.2155L9.19275 88.9812L9 88ZM0.994376 96.1059L9.99438 11.6059L8.00562 11.3941L-0.994376 95.8941L0.994376 96.1059ZM47.796 85.021L-0.203954 95.021L0.203954 96.979L48.204 86.979L47.796 85.021ZM47 80.3393V86H49V80.3393H47ZM47.8073 79.358L8.80725 87.0188L9.19275 88.9812L48.1927 81.3205L47.8073 79.358ZM10 88V11.5H8V88H10Z",
				fill: "black",
				mask: "url(#path-1-inside-1_17667_5776)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.342 58.6352C30.1405 58.4464 29.8241 58.4566 29.6352 58.658C29.4464 58.8595 29.4566 59.1759 29.658 59.3648L30.342 58.6352ZM38 66.5L37.658 66.8648L38.081 67.2613L38.4111 66.7846L38 66.5ZM29.658 59.3648L37.658 66.8648L38.342 66.1352L30.342 58.6352L29.658 59.3648ZM38.4111 66.7846L51.9111 47.2846L51.0889 46.7154L37.5889 66.2154L38.4111 66.7846Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M35.018 63.019L45.9111 47.2846L45.0889 46.7154L34.2805 62.3276L35.018 63.019ZM34.4426 63.8503L33.705 63.1588L31.919 65.7387L24.342 58.6352C24.1405 58.4464 23.8241 58.4566 23.6352 58.658C23.4464 58.8595 23.4566 59.1759 23.658 59.3648L31.658 66.8648L32.081 67.2613L32.4111 66.7846L34.4426 63.8503Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 40,
				height: 1,
				transform: "matrix(0.978148 -0.207912 0 1 16 24.3165)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 1,
				transform: "matrix(0.978148 -0.207912 0 1 16 28.6532)",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 21,
				cy: 14,
				r: 1,
				fill: "#EAEBF8"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 30,
				cy: 12,
				r: 1,
				fill: "#EAEBF8"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 41.541,
				cy: 9.75848,
				r: 1,
				fill: "#EAEBF8"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 53.3301,
				cy: 6.81335,
				r: 1,
				fill: "#EAEBF8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.9455 39.7495C17.51 38.5434 19.113 36.1769 21.0096 36.3599C23.3803 36.5887 12.8814 43.1392 16.9455 41.993C21.0096 40.8468 25.0737 35.9615 26.767 35.9326C28.4604 35.9038 21.0096 42.6416 27.1057 38.2301C31.9826 34.701 35.0081 32.9105 35.9112 32.4563",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.3298 6.81337C52.9964 3.31337 53.6911 -0.0588996 46.8298 1.31336C45.8298 1.51336 44.3298 1.81337 45.3298 2.81337",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.5408 9.7585C41.2075 6.2585 41.9021 1.8862 35.0408 3.25849C32.5409 3.75851 33.0407 4.75848 33.0408 5.25848",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M30.0408 11.7585C28.5 7.25849 29 3.99999 25.5 4.5C22.9761 4.86056 23 6.5 23 7.00001",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.041 13.3092C19.5002 8.80916 20.5002 5.49999 17.0002 6C14.4764 6.36056 15.0001 8 15.0002 8.50001",
				stroke: "black",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M10 86.7845V11.8227L64 1.21554V46.5353C64.317 46.5015 64.65 46.4849 65 46.4863V0L9 11V88L58.2662 78.3227C58.2354 77.9855 58.2061 77.6513 58.1784 77.3208L10 86.7845Z",
				fill: "#4F49BA"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66.5 57.5L56 52",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70 53.5L70.5 50",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M66 52.5L63 49",
				stroke: "#4F49BA",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5 92L9 11.5V88L58.2695 78.3221C58.3579 79.4531 58.4653 80.6337 58.5877 81.8327L5 92Z",
				fill: "#8588D8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M63.0002 95.5C61.6669 91.8333 59.7565 76.6916 60.0256 71.0412C60.5257 60.5411 66.5257 59.041 68.0257 59.041C69.5257 59.041 71.3257 59.8411 70.5257 61.0411C69.7257 62.2411 67.0257 63.5407 65.5257 66.041C64.0257 68.5414 63.8946 70.6203 66.0257 72.041C69.0257 74.041 73.5257 71.0409 74.0257 70.041C74.5257 69.2077 75.5257 66.941 75.5257 64.541C75.5257 61.541 75.5257 60.5414 75.5257 59.0414C75.5257 57.5414 74.0257 58.541 72.5257 58.541C71.0257 58.541 70.5257 58.0411 70.5257 57.5411C70.5257 57.0411 73.5257 53.0411 75.5257 52.5411C77.5257 52.0411 80.1353 53.5272 80.5257 57.0411C81.0257 61.5411 79.0257 72.0414 78.5257 72.0414C78.0257 72.0414 82.1422 54.0753 82.5257 52.5414C83.0257 50.5414 83.1537 48.6984 84.5257 49.0414C86.5257 49.5414 86.0257 58.5414 85.5257 61.5414C85.1257 63.9414 83.6924 71.208 83.0257 74.5414C83.859 73.0414 85.1257 67.341 85.5257 64.541C86.0257 61.041 87.0257 55.5414 87.5257 54.0414C88.0257 52.5414 89.4193 51.1776 90.0257 51.5414C92.5257 53.0414 88.859 68.0414 88.0257 76.0414C88.5257 76.2078 89.0257 74.0414 90.0257 70.041C91.1236 65.6488 92.5257 55.208 94.5257 56.5414C95.7257 57.3414 92.5002 74.6667 91.0002 82.5L87.5257 95.5",
				stroke: "black",
				strokeLinecap: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_17667_5776",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgStackCheckLight;
